var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.565,
    height: 27.579,
    viewBox: "0 0 22.565 27.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-verified-user",
    "data-name": "Icon material-verified-user",
    d: "M15.782,1.5,4.5,6.514v7.522c0,6.957,4.814,13.464,11.282,15.043,6.469-1.58,11.282-8.086,11.282-15.043V6.514ZM13.275,21.557,8.261,16.543l1.768-1.768,3.247,3.234,8.261-8.261,1.768,1.78Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#432a7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTick);
export default __webpack_public_path__ + "static/media/img-tick.b245b4b33bb6cd075e6e280ed86c3f77.svg";
export { ForwardRef as ReactComponent };